import * as _ from 'lodash';

export function getCommunitiesAll(state) {
  return state.communities;
}

export function getCommunities(state) {
  return _applyFilters(state.communities, state.filters);
}

export function getCommunitiesByLocation(state) {
  return (location) => {
    return _applyFilters(state.communities, state.filters).filter((c) => {
      return c.community_location.filter((l) => l.slug === location).length;
    });
  };
}

export function getCommunityLocations(state) {
  return _getCommunityLocations(state.communities);
}

export function getFilter(state) {
  return (field) => state.filters[field];
}

export function getFilters(state) {
  return state.filters;
}

/**
 * Return all the locations used in
 * @param communities
 * @return {Array|*|[]}
 * @private
 */
function _getCommunityLocations(communities) {
  return _.uniqBy(
    communities.flatMap((c) => {
      return c.community_location.filter((terms) => {
        return terms.taxonomy === 'community-location';
      });
    }),
    'slug'
  ).sort(sortByName);
}

function _applyFilters(communities, filters) {
  const keyMap = {
    floorPlans: 'floorplans',
    propertyTypes: 'property_type',
    schoolDistricts: 'school_district',
  };

  return communities.filter((c) => {
    // loop through each filter
    // if filter has options, loop through communities to only allow those that exist
    let inSet = 0;
    Object.keys(filters).forEach((key) => {
      if (filters[key].length) {
        // There are options set in this filter, so check if this community has a match
        // Floorplans is an array, so we'll handle that differently
        if (key === 'floorPlans') {
          if ( filters[key].some(r=> c.floorplans.indexOf(r) >= 0) ) {
            inSet++;
          }
        } else {
          if (filters[key].includes(c[keyMap[key]])) {
            inSet++;
          }
        }
      } else {
        // no options in this filter, so go ahead and pass
        inSet++;
      }
    });

    return inSet === Object.keys(filters).length;
  });
}

function sortByName(a, b) {
  const aa = a.name.toUpperCase();
  const bb = b.name.toUpperCase();
  if (aa < bb) {
    return -1;
  }
  if (aa > bb) {
    return 1;
  }

  // names must be equal
  return 0;
}
